<div
	class="buttons-bottom"
	[ngClass]="{
		'no-boundaries': removeBoundaries,
		'is-on-top': isOnTop,
		'add-padding': addPadding,
		'remove-top-padding': removeTopPadding
	}"
>
	<!-- use a span tag with the note id to show additional info in the buttons bottom section -->
	<p class="note">
		<ng-content select="#note"></ng-content>
	</p>
	<div *ngIf="alignRight" class="spacer"></div>
	<ng-content></ng-content>
	<div *ngIf="!alignRight" class="spacer"></div>
</div>
